module.exports = __webpack_public_path__ + "img/tf23.203ef648.jpg";